import type { BotPlan, LlmTask, LlmUsage } from './types';

/** Precio por millón de tokens en USD (entrada, entrada cacheada, salida). Actualizar cuando cambien las listas. */
export const MODEL_PRICES: Record<string, { input: number; cachedInput: number; output: number }> =
  {
    'claude-haiku-4-5-20251001': { input: 1, cachedInput: 0.1, output: 5 },
    'claude-haiku-4-5': { input: 1, cachedInput: 0.1, output: 5 },
    'claude-sonnet-5': { input: 2, cachedInput: 0.2, output: 10 },
    'claude-opus-5': { input: 5, cachedInput: 0.5, output: 25 },
    'llama-3.3-70b-versatile': { input: 0.59, cachedInput: 0.3, output: 0.79 },
    'deepseek-v3': { input: 1.25, cachedInput: 0.63, output: 1.25 },
    fake: { input: 0, cachedInput: 0, output: 0 },
  };

export function estimateCostUsd(model: string, usage: LlmUsage): number {
  const p = MODEL_PRICES[model] ??
    MODEL_PRICES[model.split(':').pop() ?? ''] ?? { input: 0, cachedInput: 0, output: 0 };
  return (
    (usage.input * p.input + usage.cachedInput * p.cachedInput + usage.output * p.output) /
    1_000_000
  );
}

/** "proveedor:modelo" → partes. */
export function parseModelRef(ref: string): { provider: string; model: string } {
  const i = ref.indexOf(':');
  return i < 0
    ? { provider: 'fake', model: ref }
    : { provider: ref.slice(0, i), model: ref.slice(i + 1) };
}

/** Modelos por plan y tarea (ADR-020, decisión 7). null = sin modelo (reglas y plantillas). */
export const PLAN_DEFAULT_MODELS: Record<BotPlan, Record<LlmTask, string | null>> = {
  BASICO: { understand: null, reply: null },
  ESTANDAR: {
    understand: 'anthropic:claude-haiku-4-5-20251001',
    reply: 'anthropic:claude-sonnet-5',
  },
  PREMIUM: { understand: 'anthropic:claude-haiku-4-5-20251001', reply: 'anthropic:claude-opus-5' },
};
